import { useState, Fragment } from 'react';
import { GetPostsType, GetPosts } from '../api/getPosts';
import { PostType } from '../types/types';
import CardItem from './CardItem';
import Pagination from './Pagination';

interface CardGridType {
	baseUrl: string;
	newTab: boolean;
	posttype?: string;
	count: number;
	paginationActive: boolean;
	selectedCategory?: string | null;
	keyFacts: boolean;
}

const CardGrid = ({ baseUrl, newTab, posttype, count, paginationActive, selectedCategory, keyFacts }: CardGridType) => {
	const [page, setPage] = useState(1);

	let url = `${baseUrl}/wp-json/wicotec/v1/articles?per_page=${count}`;

	if (paginationActive) {
		url += `&page=${page}`;
	}

	if (posttype && posttype === 'cases_post_type') {
		url += `&post_type=${posttype}`;
	}

	if (selectedCategory) {
		if (posttype === 'cases_post_type') {
			url += `&case_category=${selectedCategory}`;
		} else {
			url += `&category=${selectedCategory}`;
		}
	}

	if (keyFacts) {
		if (posttype === 'cases_post_type') {
			url += `&link=false`;
		}
	}

	const posts: GetPostsType = GetPosts(url);

	return (
		<Fragment>
			<div className={`dynamic-news__card-list card-list ${posttype === 'cases_post_type' ? ' card-list--cases card-list--4' : ' card-list--3'}${posts?.loading ? ' loading' : ''}`}>
				{posts?.data &&
					posts?.data?.results.map((post: PostType) => {
						return <CardItem key={post?.id} posttype={posttype} post={post} newTab={newTab} keyFacts={keyFacts} />;
					})}
			</div>
			{paginationActive && posts.maxPages > 1 && (
				<Pagination page={page} perPage={count} maxPages={posts.maxPages} pageChange={(nextPage) => setPage(parseInt(nextPage || '1', 10))} />
			)}
		</Fragment>
	);
};

export default CardGrid;
